import Panel, { PanelBody, PanelHeader } from '../../../../components/Panel'
import Ul from '../../../../components/Ul'
import TablePrices from './TablePrices'
import { storagePage } from '../../storage'
import {
    getProductName,
    getProductManufacturerCode
} from '../../../../utilities/productDisplay'

export default function Step1() {
    const product = storagePage.productPrice?.product_country?.product
    return (
        <>
            <Panel mode="form">
                <PanelHeader title="Detalle de precio del producto" />
                <PanelBody>
                    <Ul className="mb-4">
                        <li>
                            Producto:
                            <b className="ml-2">
                                {getProductName(product as any)}
                            </b>
                        </li>
                        <li>
                            Código de proveedor:
                            <b className="ml-2">
                                {getProductManufacturerCode(product as any)}
                            </b>
                        </li>
                    </Ul>
                    <TablePrices></TablePrices>
                </PanelBody>
            </Panel>
        </>
    )
}
